import { masmovilCard, llamayaCard, CustomTheme } from '@masfront/common-b2c'

import { makeStyles } from '@material-ui/core/styles'

const useSelectedTariffCardStyles = makeStyles(({ spacing, name, palette }: CustomTheme) => ({
  cardContainer: {
    backgroundColor:
      name === 'masmovil' ? masmovilCard.backgroundColor : llamayaCard.backgroundColor,
    display: 'flex',
    height: '96px',
    overflow: 'visible',
    position: 'relative',
    transition: 'all 0.45s ease-out',
    width: '100%',
  },
  iconContainer: {
    alignItems: 'center',
    backgroundColor: name === 'masmovil' ? masmovilCard.mainColor : llamayaCard.mainColor,
    borderRadius: '64px',
    display: 'flex',
    flexDirection: 'row',
    height: '48px',
    justifyContent: 'center',
    left: '0',
    position: 'absolute',
    top: '24px',
    transform: 'translate(-50%,0)',
    width: '48px',
  },
  icon: {
    color: '#333333',
    fontSize: 20,
  },
  title: {
    color: palette.grey[900],
    marginBottom: '10px',
    textTransform: 'uppercase',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: `${spacing(6)}px ${spacing(4)}px ${spacing(6)}px ${spacing(10)}px`,
    width: '100%',
  },
  contentInfo: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    width: '45%',
  },
  contentTariffDetail: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
  },
  info: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    marginRight: `${spacing(4)}px`,
    '& p:first-child': {
      marginRight: `${spacing(1)}px`,
      textTransform: 'capitalize',
    },
    '& p:last-child': {
      color: '#4c4c4c',
    },
  },
  pricesFlexContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '45%',
  },
  pricesContainer: {
    alignItems: 'center',
    backgroundColor: name === 'masmovil' ? masmovilCard.mainColor : llamayaCard.mainColor,
    borderRadius: '8px',
    display: 'flex',
    margin: `0 ${spacing(4)}px`,
    padding: `${spacing(1)}px ${spacing(6)}px ${spacing(1)}px ${spacing(4)}px`,
  },
  secondPrice: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: `${spacing(6)}px`,
  },
  button: {
    backgroundColor: '#FFFFFF',
    height: '31px',
    minWidth: '162px',
    width: '18%',
  },
  menu: {
    '& .MuiMenu-list': {
      padding: '0px',
    },
    '& .MuiMenu-paper': {
      borderRadius: '8px',
      marginTop: `${spacing(1)}px`,
      minWidth: '160px',
    },
    '& .MuiListItem-root': {
      justifyContent: 'center',
      padding: `0px`,
      '& p': {
        padding: `${spacing(3)}px 0px`,
        textAlign: 'center',
        width: '100%',
      },
      '& .MuiBox-root': {
        width: '100%',
      },
    },
    '& .link': {
      textDecoration: 'none',
    },
  },
  border: {
    borderBottom: `1px solid ${palette.grey[200]}`,
    borderTop: `1px solid ${palette.grey[200]}`,
  },
}))

export default useSelectedTariffCardStyles
